<template>
    <div>
        <h1>Error 404</h1>
        <p>Page not found</p>
    </div>
</template>
